import React from 'react';

// Stroke icon set — ported from the Claude Design "AdventureWorks Executive Dashboard" mock.
// Sized by parent via the `size` prop (default 18).
const Icon = ({ name, size = 18, strokeWidth = 1.75, ...rest }) => {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    ...rest,
  };
  switch (name) {
    case 'overview':
      return (
        <svg {...common}>
          <rect x="3"  y="3"  width="7" height="9" rx="1.5" />
          <rect x="14" y="3"  width="7" height="5" rx="1.5" />
          <rect x="14" y="12" width="7" height="9" rx="1.5" />
          <rect x="3"  y="16" width="7" height="5" rx="1.5" />
        </svg>
      );
    case 'globe':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
        </svg>
      );
    case 'box':
      return (
        <svg {...common}>
          <path d="M21 8 12 3 3 8v8l9 5 9-5V8z" />
          <path d="M3 8l9 5 9-5M12 13v8" />
        </svg>
      );
    case 'people':
      return (
        <svg {...common}>
          <circle cx="9" cy="8" r="3.2" />
          <path d="M3 20a6 6 0 0 1 12 0" />
          <circle cx="17" cy="9" r="2.6" />
          <path d="M15 20a5 5 0 0 1 6.5-4.8" />
        </svg>
      );
    case 'segments':
      return (
        <svg {...common}>
          <path d="M12 3a9 9 0 1 0 9 9h-9V3z" />
          <path d="M14 3a7 7 0 0 1 7 7h-7V3z" />
        </svg>
      );
    case 'profit':
      return (
        <svg {...common}>
          <path d="M3 17l6-6 4 4 8-8" />
          <path d="M14 7h7v7" />
        </svg>
      );
    case 'forecast':
      return (
        <svg {...common}>
          <path d="M3 12c4-6 7-6 9 0s5 6 9 0" />
          <circle cx="12" cy="12" r=".6" fill="currentColor" />
        </svg>
      );
    case 'settings':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-1.8-.3 1.6 1.6 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.6 1.6 0 0 0-1-1.5 1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0 .3-1.8 1.6 1.6 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.6 1.6 0 0 0 1.5-1 1.6 1.6 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 1.8.3H9a1.6 1.6 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.6 1.6 0 0 0 1 1.5 1.6 1.6 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0-.3 1.8V9a1.6 1.6 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.6 1.6 0 0 0-1.5 1z" />
        </svg>
      );
    case 'chevron-down': return <svg {...common}><path d="M6 9l6 6 6-6" /></svg>;
    case 'chevron-right': return <svg {...common}><path d="M9 6l6 6-6 6" /></svg>;
    case 'check':         return <svg {...common}><path d="M20 6L9 17l-5-5" /></svg>;
    case 'calendar':
      return (
        <svg {...common}>
          <rect x="3" y="5" width="18" height="16" rx="2" />
          <path d="M3 10h18M8 3v4M16 3v4" />
        </svg>
      );
    case 'filter':        return <svg {...common}><path d="M3 5h18l-7 9v6l-4-2v-4L3 5z" /></svg>;
    case 'menu-dots':
      return (
        <svg {...common}>
          <circle cx="5"  cy="12" r="1.4" fill="currentColor" />
          <circle cx="12" cy="12" r="1.4" fill="currentColor" />
          <circle cx="19" cy="12" r="1.4" fill="currentColor" />
        </svg>
      );
    case 'logout':
      return (
        <svg {...common}>
          <path d="M9 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4" />
          <path d="M16 17l5-5-5-5M21 12H9" />
        </svg>
      );
    default:
      return null;
  }
};

export default Icon;
